import { Avatar, Link, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { PurpleLocation } from 'Images';

interface IMapLocation {
  longitude: number;
  latitude: number;
}

export const MapLocation = ({ longitude, latitude }: IMapLocation) => {
  const isDesktop = useIsDesktop();

  return (
    <Link
      href={`https://www.google.com/maps?q=${latitude},${longitude}`}
      target='_blank'
      rel='noopener noreferrer'
      sx={{
        width: 'fit-content',
        display: 'flex',
        alignItems: 'center',
        gap: isDesktop ? '4px' : '2px',
        textDecoration: 'none',
        ':hover': {
          textDecoration: 'underline',
        },
      }}
      tabIndex={0}
    >
      <Avatar
        alt=''
        src={PurpleLocation}
        sx={{ width: '20px', height: '20px' }}
      />
      <Typography variant='body6'>
        {Dictionary[DICTIONARY.Suppliers].resultPage.therapy.map}
      </Typography>
    </Link>
  );
};
